"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessageSimple = ChatMessageSimple;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
var _utils = require("../../../utils");
var _utils2 = require("../../GroupChats/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ChatMessageSimple(props) {
  var _message$user;
  var _useMessageContext = (0, _streamChatReact.useMessageContext)(),
    message = _useMessageContext.message;
  var isChatFrozen = props.isChatFrozen,
    previewUserId = props.previewUserId,
    clinicianPatients = props.clinicianPatients;
  var msgActionsProps = isChatFrozen ? {
    getMessageActions: function getMessageActions() {
      return [];
    },
    handleReaction: _utils.noop
  } : {};
  var channelConfig = {
    replies: false,
    reactions: !isChatFrozen
  };
  var modifiedMessage = message;

  // These patients are only available in clinician app, we need it to replace nicknames for real names
  var replaceName = (0, _utils2.getSinglePatientNameByNickName)(message === null || message === void 0 ? void 0 : (_message$user = message.user) === null || _message$user === void 0 ? void 0 : _message$user.name, clinicianPatients);

  // If we have a match, we change name for a single message
  if (replaceName) {
    modifiedMessage = _objectSpread(_objectSpread({}, message), {}, {
      user: _objectSpread(_objectSpread({}, message.user), {}, {
        name: replaceName
      })
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: message.user.id === previewUserId ? 'str-chat__message-simple--me' : 'str-chat__message-simple--other'
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.MessageTeam, _extends({}, msgActionsProps, {
    message: modifiedMessage,
    channelConfig: channelConfig
  })));
}